
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
@Injectable({
  providedIn: 'root'
})
export class PlannerHelpingService {

  selectedMethod;
  constructor(private assigTripsService: AssigTripsService) {
  }

  async applyPickupWiseCalibration(selectedMethod, planedTrips, user) {
    this.selectedMethod = selectedMethod
    for (const trip of planedTrips) {
      const distance = await this.calculateDistance(
        trip.jobOriginLatitude,
        trip.jobOriginLongitude,
        trip.jobDestinationLatitude,
        trip.jobDestinationLongitude
      );

      if (!distance || !distance.duration) continue;

      trip.scheduleTime = moment(trip.appointmentTime)
        .tz(user.timeZone)
        .subtract(distance.duration, "minutes")
        .toISOString();
    }
  }

  async applyDropoffWiseCalibration(selectedMethod, planedTrips, user) {
    this.selectedMethod = selectedMethod
    for (const trip of planedTrips) {
      const distance = await this.calculateDistance(
        trip.jobOriginLatitude,
        trip.jobOriginLongitude,
        trip.jobDestinationLatitude,
        trip.jobDestinationLongitude
      );

      if (!distance || !distance.duration) continue;

      trip.appointmentTime = moment(trip.scheduleTime)
        .tz(user.timeZone)
        .add(distance.duration, "minutes")
        .toISOString();
    }
  }

  async applyMemberWiseHybridCalibration(selectedMethod, planedTrips, user) {
    // Group trips by client
    this.selectedMethod = selectedMethod
    const tripsByClient = {};
    for (const trip of planedTrips) {
      if (!tripsByClient[trip.client]) tripsByClient[trip.client] = [];
      tripsByClient[trip.client].push(trip);
    }

    // Process each client’s trips
    for (const clientId in tripsByClient) {
      const clientTrips = tripsByClient[clientId];

      // sort trips in order
      clientTrips.sort((a, b) =>
        moment(a.scheduleTime || a.appointmentTime).isBefore(
          moment(b.scheduleTime || b.appointmentTime)
        )
          ? -1
          : 1
      );


      for (let i = 0; i < clientTrips.length; i++) {
        const trip = clientTrips[i];
        const distance = await this.calculateDistance(
          trip.jobOriginLatitude,
          trip.jobOriginLongitude,
          trip.jobDestinationLatitude,
          trip.jobDestinationLongitude
        );

        if (!distance || !distance.duration) continue;

        if (i === 0) {
          // first trip = pickup-wise
          console.log("pickup-wise", clientTrips.length )
          trip.scheduleTime = moment(trip.appointmentTime)
            .tz(user.timeZone)
            .subtract(distance.duration, "minutes")
            .toISOString();
        } else {
                    // first trip = pickup-wise
          console.log("dropoff-wise", clientTrips.length)
          // subsequent trips = dropoff-wise
          trip.appointmentTime = moment(trip.scheduleTime)
            .tz(user.timeZone)
            .add(distance.duration, "minutes")
            .toISOString();
        }
      }
    }
  }


  async calculateDistance(lat1, lon1, lat2, lon2) {
    return await this.assigTripsService.getDistance(lat1, lon1, lat2, lon2, this.selectedMethod);
  }


  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }

}
